import {TableColumnsType} from 'antd';
import {SorterResult} from 'antd/es/table/interface';
import {z} from 'zod';

import {Locale} from '../../../../provider/locale/locale';

import {CompanyGroupTableRowDataType} from './companies-group-table-type';

export const PAGE_SIZE_STORAGE_KEY = 'companiesGroupPageSize';
export const pageSizeSchema = z.number();
export const SEARCH_MIN_LENGTH = 2;

// Maps table dataIndex to the server-side ordering field accepted by `o=` on the company_groups endpoint.
const companiesGroupOrderingFieldMap: Record<string, string> = {
    name: 'title',
    count: 'companies_count',
};

// Converts an Ant Design sorter result into the server-side `o=` value (e.g. `title`, `-companies_count`).
export function getOrderingValue(
    sorter: SorterResult<CompanyGroupTableRowDataType> | Array<SorterResult<CompanyGroupTableRowDataType>>
): string | null {
    if (Array.isArray(sorter) || !sorter.order || typeof sorter.field !== 'string') {
        return null;
    }

    const field = companiesGroupOrderingFieldMap[sorter.field];

    if (!field) {
        return null;
    }

    return sorter.order === 'descend' ? `-${field}` : field;
}

// Quick search hits the backend only from SEARCH_MIN_LENGTH characters; below it resets to the full list.
export function resolveSearchQuery(debouncedValue: string): string | null {
    return debouncedValue.length >= SEARCH_MIN_LENGTH ? debouncedValue : null;
}

export const companiesGroupColumnList: TableColumnsType<CompanyGroupTableRowDataType> = [
    {
        title: <Locale stringKey="GROUP_OF_COMPANIES__TABLE__NAME" />,
        dataIndex: 'name',
        align: 'left',
        sorter: true,
    },
    {
        title: <Locale stringKey="GROUP_OF_COMPANIES__TABLE__COMPANIES" />,
        dataIndex: 'count',
        align: 'right',
        sorter: true,
    },
    {
        title: <Locale stringKey="GROUP_OF_COMPANIES__TABLE__ACTION" />,
        dataIndex: 'action',
        align: 'center',
    },
];
